<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="cancel">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
            </div>
        </div>

          <div class="modal-body">
            <RequiredText />
            <form id="kt_modal_new_target_form" @submit.prevent="createRightData" class="form" >
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span class="required">{{$t('right.name')}}</span>
                </label>
                <input type="text" required class="form-control form-control-solid" v-model="formCreateData.name" :placeholder="$t('right.name_placeholder')" />
              </div>
              <div class="d-flex flex-column mb-8 fv-row">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                  <span >{{$t('right.description')}}</span>
                </label>
                <input type="text" class="form-control form-control-solid" v-model="formCreateData.description" :placeholder="$t('right.description_placeholder')" />
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="cancel"></Button>
                <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </form>
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { defineProps,ref } from 'vue';
import { useStore } from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"

const props = defineProps({
  id: { type: String, default: 'createModal'},
  formCreate:{
    type:Object,
    default:{}
  },
  parent: { type: String, required: false},
  hasParent: { type: Boolean, required: false},
})

const store = useStore()

const  formCreateData = ref({name:'',description:''})

const isLoading = ref(false)

const emit = defineEmits(['reloadDatatable'])

const cancel = () => {
  if(props.hasParent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}

const createRightData = async () => {
  isLoading.value = true
  let data = {
    name: formCreateData.value.name,
    description: formCreateData.value.description
  }
  let response = {}
  try{
    response = await store.dispatch('role/createRole', data)
    window.toastr.success(i18n.global.t("notification.right_created"))
    emit('reloadDatatable', response.data?.role?.id)
    formCreateData.value = {
      name: '',
    }
    isLoading.value = false
    cancel()
  }catch(err){
    isLoading.value = false
  }
}

</script>
